"use client";

import React from "react";

export default function CookiesPolicyPage() {

	return (
		<div className='cookies-wrapper'>
			<style jsx>{`
				.cookies-wrapper {
					background-color: #f5f7fa;
					min-height: 100vh;
					display: flex;
					justify-content: center;
					align-items: flex-start;
					padding: 60px 20px;
					font-family: "Inter", Arial, sans-serif;
					color: #333;
				}

				.cookies-container {
					background: #fff;
					max-width: 900px;
					width: 100%;
					padding: 50px 60px;
					border-radius: 16px;
					box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
				}

				.cookies-title {
					font-size: 2.4rem;
					font-weight: 700;
					color: #111;
					margin-bottom: 10px;
				}

				.cookies-meta {
					color: #666;
					font-size: 0.95rem;
					margin-bottom: 40px;
				}

				h2 {
					font-size: 1.4rem;
					color: #111;
					margin-top: 40px;
					margin-bottom: 12px;
				}

				h3 {
					font-size: 1.1rem;
					color: #222;
					margin-top: 25px;
					margin-bottom: 10px;
				}

				p {
					line-height: 1.7;
					margin-bottom: 16px;
				}

				ul {
					list-style: disc;
					margin-left: 25px;
					margin-bottom: 16px;
				}

				a {
					color: #0077cc;
					text-decoration: none;
				}

				a:hover {
					text-decoration: underline;
				}

				.cookies-button {
					display: inline-block;
					padding: 10px 30px;
					background: #f8f9fa;
					color: #555;
					border: 1px solid #ccc;
					border-radius: 6px;
					cursor: pointer;
					transition: all 0.2s ease;
				}

				.cookies-button:hover {
					background: #e9ecef;
					color: #000;
				}

				.table-wrapper {
					width: 100%;
					overflow-x: auto;
					margin-bottom: 25px;
				}

				table {
					width: 100%;
					border-collapse: collapse;
					font-size: 0.95rem;
				}

				th,
				td {
					padding: 12px 10px;
					text-align: left;
					border-bottom: 1px solid #e5e5e5;
				}

				th {
					background-color: #f2f2f2;
					color: #111;
					font-weight: 600;
				}

				td {
					color: #444;
				}

				.cookies-footer {
					margin-top: 40px;
					font-size: 0.9rem;
					color: #777;
					text-align: center;
				}

				@media (max-width: 768px) {
					.cookies-container {
						padding: 30px 20px;
					}

					.cookies-title {
						font-size: 2rem;
					}

					table {
						font-size: 0.85rem;
					}
				}
			`}</style>
			<div className='cookies-container'>
				<h1 className='cookies-title'>Politica de cookie-uri</h1>
				<p className='cookies-meta'>
					Data intrării în vigoare: <strong>11 februarie 2026</strong> <br />
					Ultima actualizare: <strong>11 februarie 2026</strong>
				</p>

				<h2>Ce sunt cookie-urile?</h2>
				<p>
					Această Politică privind cookie-urile explică ce sunt cookie-urile, cum le folosim, tipurile de
					cookie-uri pe care le utilizăm și cum poți gestiona setările tale pentru cookie-uri.
				</p>
				<p>
					Cookie-urile sunt fișiere text mici utilizate pentru a stoca cantități reduse de informații.
					Ele sunt salvate pe dispozitivul tău atunci când un site web se încarcă în browser. Acestea
					ajută la funcționarea corectă a site-ului, la îmbunătățirea securității și oferă o experiență
					de navigare mai bună.
				</p>

				<h2>Cum folosim cookie-urile?</h2>
				<p>
					La fel ca majoritatea site-urilor, folosim cookie-uri proprii și ale terților pentru diverse
					scopuri. Cookie-urile proprii sunt necesare pentru funcționarea corectă a site-ului, iar cele
					ale terților ne ajută să analizăm traficul, să oferim reclame relevante și să îmbunătățim
					experiența utilizatorilor.
				</p>

				<h2>Tipuri de cookie-uri pe care le folosim</h2>

				<h3>Necesar</h3>
				<p>
					Cookie-urile necesare permit funcționarea de bază a site-ului, precum autentificarea sigură sau
					salvarea preferințelor. Nu colectează date personale.
				</p>
				<div className='table-wrapper'>
					<table>
						<thead>
							<tr>
								<th>Cookie</th>
								<th>Durată</th>
								<th>Descriere</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>cookie_consent</td>
								<td>1 an</td>
								<td>Cookie folosit pentru a salva preferințele de consimțământ.</td>
							</tr>
							
						</tbody>
					</table>
				</div>

                    <p>Website-ul utilizează exclusiv cookie-ul cookie_consent, folosit pentru memorarea preferințelor exprimate de vizitatori. Nu sunt utilizate cookie-uri de analiză, marketing sau profilare. Durata de stocare a cookie-urilor este de 12 luni ( 1 an ), iar preferințele pot fi modificate din bannerul de consimțământ.</p>

				<h3>Funcționale</h3>
				<p>
					Cookie-urile funcționale ajută la activarea unor funcții suplimentare precum partajarea pe
					rețele sociale sau colectarea feedback-ului.
				</p>
				<div className='table-wrapper'>
					<table>
						<thead>
							<tr>
								<th>Cookie</th>
								<th>Durată</th>
								<th>Descriere</th>
							</tr>
						</thead>
						<tbody>
							
						</tbody>
					</table>
				</div>

				<h3>Analitice</h3>
				<p>
					Cookie-urile analitice ne ajută să înțelegem modul în care utilizatorii interacționează cu
					site-ul, colectând informații anonime despre trafic și performanță.
				</p>
				<div className='table-wrapper'>
					<table>
						<thead>
							<tr>
								<th>Cookie</th>
								<th>Durată</th>
								<th>Descriere</th>
							</tr>
						</thead>
						<tbody>
		
						</tbody>
					</table>
				</div>

				<h3>Necategorizate</h3>
				<p>
					Cookie-urile necategorizate sunt cele care sunt analizate și nu au fost încă clasificate într-o
					categorie specifică.
				</p>
				<div className='table-wrapper'>
					<table>
						<thead>
							<tr>
								<th>Cookie</th>
								<th>Durată</th>
								<th>Descriere</th>
							</tr>
						</thead>
						<tbody>
					
						</tbody>
					</table>
				</div>
	
				<ul>
					<li>
						Chrome:{" "}
						<a
							href='https://support.google.com/accounts/answer/32050'
							target='_blank'
							rel='noreferrer'>
							suport Google
						</a>
					</li>
					<li>
						Safari:{" "}
						<a
							href='https://support.apple.com/en-in/guide/safari/sfri11471/mac'
							target='_blank'
							rel='noreferrer'>
							suport Apple
						</a>
					</li>
					<li>
						Firefox:{" "}
						<a
							href='https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox'
							target='_blank'
							rel='noreferrer'>
							suport Mozilla
						</a>
					</li>
					<li>
						Internet Explorer:{" "}
						<a
							href='https://support.microsoft.com/en-us/topic/how-to-delete-cookie-files-in-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc'
							target='_blank'
							rel='noreferrer'>
							suport Microsoft
						</a>
					</li>
				</ul>


			</div>
    
		</div>
	);
}
